var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchIconComparison(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_217_635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.56 13.1229C10.183 13.1229 13.1201 10.1859 13.1201 6.56281C13.1201 2.93973 10.1831 0.00271606 6.56 0.00271606C2.93692 0.00271606 -0.000125885 2.93977 -0.000125885 6.56284C-0.000125885 10.1859 2.93696 13.1229 6.56 13.1229ZM6.56 1.87705C9.1479 1.87705 11.2458 3.97493 11.2458 6.56284C11.2458 9.15074 9.1479 11.2486 6.56 11.2486C3.97209 11.2486 1.8742 9.15074 1.8742 6.56284C1.8742 3.97493 3.97213 1.87705 6.56 1.87705Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0574 14.9972C14.3065 14.9987 14.5459 14.9009 14.7228 14.7255C15.0903 14.361 15.0927 13.7676 14.7282 13.4001C14.7264 13.3983 14.7246 13.3965 14.7228 13.3947L11.1991 9.871C10.8187 9.5035 10.2124 9.514 9.84486 9.89442C9.47737 10.2748 9.48787 10.8811 9.86828 11.2486L13.392 14.7255C13.5689 14.9009 13.8083 14.9987 14.0574 14.9972Z",
    fill: "#BFBFBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_217_635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "matrix(-1 0 0 1 15 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconComparison);
export default __webpack_public_path__ + "static/media/search-icon-comparison.86aa1260eb195bf9e88d0b8c5aa9d368.svg";
export { ForwardRef as ReactComponent };